export const emptyChatNotifications = () => ({ records: [], removedIds: [] });
export const isChatParticipant = (chat, userId) => Array.isArray(chat?.users) && chat.users.some(member => Number(member.userId) === Number(userId));
const sameId = (first, second) => String(first) === String(second);
const upsert = (records, chat, prepend = true) => records.some(current => sameId(current.id, chat.id))
  ? records.map(current => sameId(current.id, chat.id) ? { ...current, ...chat } : current)
  : prepend ? [chat, ...records] : [...records, chat];

export function chatNotificationReducer(state, action) {
  if (action.type === "RESET") return emptyChatNotifications();
  if (action.type === "LOAD_CHATS") {
    let records = state.records;
    for (const chat of action.payload || []) {
      if (!state.removedIds.some(id => sameId(id, chat.id)) && isChatParticipant(chat, action.userId)) records = upsert(records, chat, false);
    }
    return { ...state, records };
  }
  if (action.type !== "CHAT_EVENT") return state;
  const event = action.payload;
  const chat = event.record || event.chat;
  const id = event.id ?? chat?.id;
  if (event.action === "delete" || event.action === "remove" || (chat && !isChatParticipant(chat, action.userId))) {
    if (id === undefined || id === null) return state;
    return { records: state.records.filter(current => !sameId(current.id, id)), removedIds: [...new Set([...state.removedIds, String(id)])] };
  }
  if (!["create", "update", "new-message"].includes(event.action) || !chat) return state;
  return { records: upsert(state.records, chat), removedIds: state.removedIds.filter(id => !sameId(id, chat.id)) };
}

export const chatUnreadCount = (records, userId) => records.reduce((total, chat) => total + (Number(chat.users?.find(member => Number(member.userId) === Number(userId))?.unreads) || 0), 0);
